import {charcoal} from '../../sass/v2/_exports.sass';

export const DiagonalLinesIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Backgrounds</title>
      <path
        d="M4.17476 30C3.68284 29.8962 3.2233 29.6306 2.79612 29.2028C2.36893 28.775 2.10356 28.3149 2 27.8222L27.7864 2C28.3301 2.12963 28.7961 2.39537 29.1845 2.79722C29.5728 3.19907 29.8447 3.65926 30 4.17778L4.17476 30ZM2 20.2V15.8444L15.8252 2H20.1748L2 20.2ZM2 8.22222V5.11111C2 4.25556 2.30421 3.52315 2.91262 2.91389C3.52104 2.30463 4.25243 2 5.1068 2H8.21359L2 8.22222ZM23.7476 30L29.9612 23.7778V26.8889C29.9612 27.7444 29.657 28.4768 29.0485 29.0861C28.4401 29.6954 27.7087 30 26.8544 30H23.7476ZM11.7864 30L29.9612 11.8V16.1556L16.1359 30H11.7864Z"
        fill={color}
      />
    </svg>
  );
};
